"use client";

import { useEffect } from "react";

export default function FixPreloadLinks() {
  useEffect(() => {
    const preloadLinks = document.querySelectorAll(
      'link[rel="preload"][as="image"][imagesrcset]:not([href])',
    );

    preloadLinks.forEach((link) => {
      const imagesrcset = link.getAttribute("imagesrcset");
      if (imagesrcset) {
        // Extract the first URL from the srcset string
        const match = imagesrcset.match(/^([^\s]+)/);
        if (match) {
          link.setAttribute("href", match[1]);
        }
      }
    });
  }, []);

  return null; // This component doesn't render anything
}
